import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";


const Container = styled.div`
  position: relative;
  padding: 2px 0px 2px 5px;
  margin-right: 5px;
  display: flex;
  align-items: center;
  cursor: help;

  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  border-left: 1px solid transparent;
  ${props => props.isOpen ? `
    background-color: ${props.backgroundColor || '#ECF8FD'};
    border-color: ${props.color || '#0F81B3'};
  ` : ''}

  ${props => props.fixed ? ` border-radius: 100px; border: 1px solid ${props.color || '#0F81B3'}; cursor: default;` : `
   border-bottom-left-radius: 100px;
    border-top-left-radius: 100px;
  `}
`;

const StatusIconWrapper = styled.div`
  box-sizing: border-box;
  min-width: 24px;
  max-width: 24px;
  min-height: 24px;
  max-height: 24px;
  ${props => props.color ? `color: ${props.color};` : 'color: #0F81B3;'}
`;

const ForcedStatusIconWrapper = styled(StatusIconWrapper)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ForcedIconPositioner = styled.div`
  border-radius: 100px;
  background-color: #434B4D;
  box-sizing: border-box;
  min-width: 18px;
  max-width: 18px;
  min-height: 18px;
  max-height: 18px;
  color: white;
  padding: 2px;

  svg {
    display: block !important;
  }
`;

const LabelWrapper = styled.div`
  padding-right: 5px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  color: ${props => props.color || '#0F81B3'};

  ${props => props.fixed ? `` :
  `
    position: absolute;
    display: flex;
    align-items: center;
    top: -1px;
    bottom: -1px;
    left: 100%;
    white-space: nowrap;
    border-bottom-right-radius: 100px;
    border-top-right-radius: 100px;
    border-top: 1px solid ${props.color};
    border-right: 1px solid ${props.color};
    border-bottom: 1px solid ${props.color};
    background-color: ${props.backgroundColor};
  `}

`;

const Label = styled.span`
  font-size: 14px;
`;

const statusMap = {
  mandatory: {
    label: 'Mandatory',
    color: '#434B4D',
    backgroundColor: '#eff0f0'
  },
  recommanded: {
    label: 'Recommended',
    color: '#3DCD58',
    backgroundColor: '#ecfaee'
  },
  highly_recommanded: {
    label: 'Highly recommended',
    color: '#F28A0F',
    backgroundColor: '#fef3e7'
  }
};

class StatusTooltip extends React.Component {
  static propTypes = {
    status: PropTypes.string,
    message: PropTypes.string,
    getLabel: PropTypes.func,
    fixed: PropTypes.bool,
    cursor: PropTypes.string
  };

  constructor (props) {
    super(props);
    this.state = {
      isOpen: false
    }
  }

  renderStatusIcon = (status) => {
    let result;

    switch (status) {
      case 'mandatory':
        result = (<ForcedStatusIconWrapper >
          <ForcedIconPositioner onMouseOver={() => { this.setState({ hover: true }); }} onMouseLeave={() => { this.setState({ hover: false }); }}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M688 895c80 0 144-65 144-144V608c0-67-45-125-108-141V344c-6-116-97-207-213-213-124-6-228 90-233 214v131c-16 7-31 17-44 30-27 27-42 64-42 102v143c0 78 64 143 143 144h353zM337 506h53c11 0 21-9 21-21V348c2-47 42-85 91-86 45 0 82 37 83 82v119h-81c-11 0-21 10-21 22v52c-40 10-70 46-70 89 0 51 41 91 91 91 51 0 92-40 92-90 0-10-2-19-4-28-4-11-16-18-27-14-11 3-18 15-14 27 1 4 2 9 2 14 0 27-22 49-49 49-26 0-48-22-48-49s22-48 48-48c12 0 22-10 22-22v-50h80c12 0 21-10 21-21V344c0-69-56-124-126-124h-1c-70 0-128 56-132 127v117h-48V346c3-48 23-93 59-125 36-33 82-49 130-47 94 4 168 78 172 171v140c0 10 8 19 19 21 51 6 90 50 90 102v143c0 56-46 101-102 101H335c-55 0-100-46-100-101V608c0-27 10-53 29-72 20-19 45-30 73-30z"/></svg>
          </ForcedIconPositioner>
        </ForcedStatusIconWrapper>);
        break;
      case 'recommanded':
        result = (<StatusIconWrapper color={'#0A9A25'}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M512 128c212 0 384 172 384 384S724 896 512 896 128 724 128 512s172-384 384-384zm-32 150c-8 8-11 20-11 31l11 249c0 9 3 18 10 24 6 5 14 8 22 8 9 0 17-3 23-8 6-6 10-15 9-24l13-249c0-12-5-23-13-31-9-9-20-13-32-13s-24 4-32 13zm67 469v-1c10-9 16-22 15-36 0-13-5-26-15-35-9-9-22-15-35-14-14-1-26 5-36 14-9 9-15 22-14 35-1 14 5 28 15 37 20 18 50 18 70 0z"/></svg>
        </StatusIconWrapper>);
        break;
      case 'highly_recommanded':
        result = (<StatusIconWrapper color={'#E47F00'}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M882 743c9 14 13 31 14 48 0 19-8 37-23 50-17 12-38 18-59 18H210c-21 0-42-6-59-18-14-13-23-31-23-50 1-17 5-34 14-48l303-533c13-26 38-43 67-45 29 2 54 19 67 45zM487 372c-7 6-11 15-10 25l10 196c-1 7 2 14 7 19 5 4 12 7 18 6 6 0 13-2 18-6 5-5 8-12 7-19l10-196c1-10-3-19-10-25-14-14-36-14-50 0zm53 369c8-7 13-18 12-29 0-11-4-21-12-27-15-16-40-16-56 0-15 15-15 41 0 56 8 7 18 11 28 11 11 0 20-4 28-11z"/></svg>
        </StatusIconWrapper>);
        break;
      default:
        result = (<></>);
        break;
    }

    return result;
  }

  render = () => {
    const hoverProps =  {
      onMouseOver: () => { this.setState({ isOpen: true }); },
      onMouseLeave: () => { this.setState({ isOpen: false }); }
    };

    const shouldOpen = this.state.isOpen || this.props.fixed;
    return (
      <Container {...hoverProps} fixed={this.props.fixed} isOpen={shouldOpen} backgroundColor={statusMap[this.props.status]?.backgroundColor} color={statusMap[this.props.status]?.color} cursor={this.props.cursor}>
        {this.renderStatusIcon(this.props.status)}
        {shouldOpen && <LabelWrapper fixed={this.props.fixed} backgroundColor={statusMap[this.props.status]?.backgroundColor} color={statusMap[this.props.status]?.color}><Label>{this.props.message ? this.props.message : statusMap[this.props.status]?.label}</Label></LabelWrapper>}
      </Container>
    );
  };
}

export default StatusTooltip;
